/**
 * Afişi yüklenmemiş kampanyaya stok fotoğraf (16 Eki 2026).
 *
 * Fotoğraflar public/kampanya/ altında, hepsi CC0 (StockSnap ve rawpixel,
 * Openverse üzerinden; atıf gerekmiyor). Kampanyanın kapsadığı ürün ve
 * kategori adlarında en çok geçen türün fotoğrafı seçiliyor; hiçbiri
 * tutmazsa ya da kampanya bütün menüdeyse genel sofra fotoğrafı.
 */

const KINDS: { file: string; words: string[] }[] = [
  { file: 'tatli', words: ['tatlı', 'pasta', 'baklava', 'künefe', 'sütlaç', 'kek', 'dondurma', 'profiterol', 'kazandibi', 'cheesecake', 'waffle', 'tiramisu', 'kadayıf', 'revani', 'brownie', 'magnolia', 'muhallebi', 'helva', 'lokum', 'trileçe'] },
  { file: 'cay', words: ['çay', 'sıcak içecek', 'bitki', 'ihlamur', 'salep', 'adaçayı'] },
  { file: 'kahve', words: ['kahve', 'latte', 'espresso', 'americano', 'cappuccino', 'mocha', 'filtre', 'macchiato', 'flat white', 'sıcak çikolata'] },
  { file: 'soguk', words: ['limonata', 'kola', 'ayran', 'soda', 'meyve suyu', 'içecek', 'smoothie', 'frozen', 'buzlu', 'şerbet', 'gazoz', 'milkshake', 'fanta', 'sprite', 'şalgam', 'portakal suyu'] },
  { file: 'hamur', words: ['börek', 'böreğ', 'poğaça', 'simit', 'açma', 'kruvasan', 'croissant', 'çörek', 'gözleme', 'hamur', 'pişi', 'fırın'] },
  { file: 'et', words: ['kebap', 'kebab', 'köfte', 'et', 'ızgara', 'döner', 'tavuk', 'şiş', 'pirzola', 'bonfile', 'adana', 'urfa', 'iskender', 'kanat', 'biftek', 'steak', 'kuzu', 'beyti', 'ana yemek', 'yemek'] },
  { file: 'burger', words: ['burger', 'pizza', 'patates', 'tost', 'sandviç', 'wrap', 'hot dog', 'dürüm', 'nugget', 'fast food'] },
  { file: 'kahvalti', words: ['kahvaltı', 'menemen', 'omlet', 'yumurta', 'sucuklu', 'serpme', 'kahvaltılık'] },
]

const words = (s: string) => s.toLocaleLowerCase('tr-TR')

/** Ad listesine en uygun stok fotoğrafın adresi. */
export function stockCampaignImage(names: string[]): string {
  const text = ` ${names.map(words).join(' | ')} `
  let best = 'genel'
  let bestHits = 0
  for (const k of KINDS) {
    let hits = 0
    for (const w of k.words) {
      // Kelime başında: "et" "sebzeli"de, "çay" "çaydanlık"ta yakalanmasın diye
      // önünde boşluk ya da ayraç aranıyor.
      const re = new RegExp(`(^|[\\s|,(/-])${w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'u')
      if (re.test(text)) hits++
    }
    if (hits > bestHits) {
      best = k.file
      bestHits = hits
    }
  }
  return `/kampanya/${best}.jpg`
}
